import { Box, CircularProgress } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Alert } from "@mui/material";
import { health_api } from "../../../Config";
import { useSearchParams } from "react-router-dom";
import { decryptData } from "../../../Framework/Utils/decrypt.js"
import {encryptData} from "../../../Framework/Utils/encrypt.js"

const RelianceKycPage = () => {
  const proposalData = useSelector((e) => e?.healthReducer?.healthproposalData);
  console.log(proposalData,"hgsdjhgsdjhsj")
  const [loading, setLoading] = useState(true);
   const [responseText, setResponseText] = useState("");
 const [params]=useSearchParams();

  useEffect(() => {
    const fetchProposalData = async () => {

      let data = {
        ...proposalData,
      };
      let CkycNumber=params?.get("ckyc_number")
      console.log(CkycNumber,"sdhjsdjsjhds")

      

      try {
        setResponseText("Submitting Proposal")
       let encrypted=encryptData(data);
          const proposalResponse = await axios.post(
            `${health_api}/insurance/v1/health/policy/proposal`,
            // data
              //  "http://localhost:8083/insurance/v1/health/proposal",
            { payload:encrypted}
          );
        


          
          let resObj = decryptData(proposalResponse.data) 

          
         
        

          if (resObj?.statusCode === 200) {
            let proposalNumber =
              resObj?.body?.Policy?.ProposalNo || null;
            let Amount = resObj?.body?.Premium?.FinalPremium
            let panNumber=data?.proposerData?.pan
          
            let form60=false;
            if(params.get("kyc_process")){
              form60=true;
            }
            console.log(proposalNumber,Amount,"hghjsadgjhgdsj")
            if(resObj?.body?.ErrorMessages?.ErrMessages==="" || resObj?.body?.ErrorMessages?.ErrMessages===null ){
             window.location.href=`https://api.brobotinsurance.com/common/PaymentIntegration/PaymentIntegration?ProposalNo=${proposalNumber}&userID=100002API&ProposalAmount=${Amount}&PaymentType=1&Responseurl=https://www.lmvinsurance.com/health/thank_you&CKYC=${CkycNumber}&IsDocumentUpload=false&PanNo=${panNumber}&IsForm60=${form60}&subscription-key=39ea4a55d8294f6586a26ace770d2faf` 
            }else{
              setLoading(false);
              setResponseText(resObj?.body?.ErrorMessages?.ErrMessages)
            }
           
          }
        
      } catch (err) {
        console.log("checksum error", err);
        if (err.status === 504) {
          setResponseText("Proposal Submission Failed Due to TimeOut Please Refresh and Try Again ")
        }
        // setLoading(false);
      }
    };

    fetchProposalData();
  }, [params,proposalData]);
 
  
  return (
    <div>
      {loading ? (
        <Box
          sx={{
            height: "600px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
           <Box
                      sx={{
                        height: "70px",
                        maxWidth: "500px",
                        position: "absolute",
                        bottom: 20,
                        right: 20,
                      }}
                    >
                      {responseText && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                          {responseText}
                        </Alert>
                      )}
                    </Box>
        </Box>
      ) : (
        <Box sx={{  height: "500px", maxWidth: "400px", margin: "auto",  justifyContent: "center",
          alignItems: "center", display: "flex"}}>
          {responseText && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {responseText}
            </Alert>
          )}
        </Box>
      )}
    </div>
  );
  
};

export default RelianceKycPage;
